import { virtualPageview, pushGAInteraction } from '../../shared/utils/googleAnalytics';

const logTroubleshootingGAEvent = ({ troubleshootingGuide, interaction, label }) => {
  pushGAInteraction({
    event: `${troubleshootingGuide}-troubleshoot`,
    interaction,
    label,
  });
};

export const pushFormFieldInteraction = (troubleshootingGuide, contentKey, value) => {
  const interaction = `${contentKey}-field-input`;
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction, label: value });
};

export const pushBackClickInteraction = (troubleshootingGuide, screen) => {
  const interaction = 'back-click';
  const label = screen ? `${screen}_screen` : 'from_browser_history';
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction, label });
};

export const pushNextClickInteraction = (troubleshootingGuide, screen) => {
  const interaction = 'next-click';
  const label = `${screen}_screen`;
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction, label });
};

export const pushNextContactUsInteraction = (troubleshootingGuide, url) => {
  const interaction = 'next-contact-us';
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction, label: url });
};

export const pushVideoInteraction = ({ videoName, interaction }) => {
  pushGAInteraction({
    event: 'video',
    interaction,
    label: videoName,
  });
};

export const pushVirtualPageview = (path, screenName) => {
  virtualPageview.pushPageview({
    virtualPageUrl: `/virtual${path}/${screenName}`,
    virtualPageTitle: screenName,
  });
};

export const pushHyperlinkClickInteraction = (troubleshootingGuide, url) => {
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction: 'clicked-hyperlink', label: url });
};

export const pushNavigationLinkClickInteraction = (troubleshootingGuide, screen) => {
  const interaction = 'navigation-link-click';
  const label = `${screen}_screen`;
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction, label });
};

export const pushFileUploadClickInteraction = (troubleshootingGuide, interaction, value) => {
  logTroubleshootingGAEvent({ troubleshootingGuide, interaction, label: value });
};
